import { WorkflowApprovalSettingsUI, type WorkflowApprovalSettingsUIProps } from '../approval-settings/components/WorkflowApprovalSettingsUI';

export function WorkflowApprovalSettingsPage(props: WorkflowApprovalSettingsUIProps) {
  return <WorkflowApprovalSettingsUI {...props} />;
}
